import React, {useEffect, useRef, useState} from "react";
import "../../styles/components/tasks.css";

const AddressSearch = ({ onPlaceSelected, latitude, longitude, address }) => {
  const inputRef = useRef(null);
  const [inputAddress, setInputAddress] = useState("");

  useEffect(() => {
    setInputAddress(address || "");
  }, [address]);

  useEffect(() => {
    if (window.google) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ['geocode', 'establishment'],
          componentRestrictions: { country: "in" },
          libraries:['Places']
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          const { lat, lng } = place.geometry.location.toJSON();
          const formattedAddress = place.formatted_address;
          setInputAddress(formattedAddress);
          onPlaceSelected(lat, lng, formattedAddress);
        }
      });
    }
  }, [onPlaceSelected]);

  const handleAddressChange = (e) => {
    setInputAddress(e.target.value);
    if (!e.target.value) {
      onPlaceSelected("", "", "");
    }
  };

  return (
    <div style={{display: 'flex', gap: '8px', width: '100%'}}>
      <input
        ref={inputRef}
        className="form-control"
        style={{ flex: 3 }}
        placeholder="Search Google Address"
        type="text"
        value={inputAddress}
        onChange={handleAddressChange}
      />
      <input
        className="form-control"
        style={{ flex: 1 }}
        type="text"
        placeholder="Lat"
        value={latitude || ""}
        readOnly
      />
      <input
        className="form-control"
        style={{ flex: 1 }}
        type="text"
        placeholder="Lng"
        value={longitude || ""}
        readOnly
      />
    </div>
  );
};

export default AddressSearch;